import React, {useEffect, useRef, useState} from "react";
import FullScreenLoadingOverlay from "./FullScreenLoadingOverlay";
import ErrorModal from "./ErrorModal";
import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import AlertPopup from "./AlertPopup";
import I18n from 'i18n.js.erb'
import {
  BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE, DESKTOP_WIDTH, displayTranslations,
  EXPANSIONS_KEY_FOR_SESSION_STORAGE, getArtwork, getGradingNameFromGrade, IPAD_WIDTH,
  parseBigInteger, parseBlueprintImageNameAndEdition, parseCategoryName, parseLanguage,
  SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE,
  titleize,
  parseEncasing, isDefined, compareStrings
} from "../../utils/utils";
import SuccessModal from "./SuccessModal";
import ShowLargeImageModal from "./ShowLargeImageModal";
import {onKeyDownQuantity} from "../../utils/utils";
import RequiredLoginAlertPopup from "./RequiredLoginAlertPopup.jsx"
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'
import BlueprintImageFlowMarketModal from "./BlueprintImageFlowMarketModal";
import GameNameParser from "./GameNameParser";
import SuccessFlashMessage from "./SuccessFlashMessage";
import LanguageFlag from "./LanguageFlag";


function useComponentVisible(initialIsVisible) {
  const [isComponentVisible, setIsComponentVisible] = useState(
    initialIsVisible
  );
  const ref = useRef(null);

  // const handleHideDropdown = (event: KeyboardEvent) => {
  const handleHideDropdown = (event) => {
    if (event.key === "Escape") {
      setIsComponentVisible(false);
    }
  };

  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      setIsComponentVisible(false);
    }
  };

  useEffect(() => {
    document.addEventListener("keydown", handleHideDropdown, true);
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("keydown", handleHideDropdown, true);
      document.removeEventListener("click", handleClickOutside, true);
    };
  });

  return {ref, isComponentVisible, setIsComponentVisible};
}


const ShowBlueprintImage = ({
    logged_in_user,
    game_id,
    blueprint_image,
    hasOffers,
    gradedCardsCount,
    gradingsByScore,
    qualifiersByScore,
    gradingsByEncasing,
    gradedProductsByEncasingCount,
    viewAigPopulation,
    marketFlow,
    disable_marketplace
  }) => {
  
  const blueprintImage = JSON.parse(blueprint_image);

  const initializeCarouselImageType = () =>{
    if (blueprintImage['xx_large_carousel_images_urls'] !== null){
      var img_references = []
      blueprintImage['xx_large_carousel_images_urls'].map((element)=>{
        var key = Object.keys(element)
        img_references.push(key[0].replace('xx_large_', '').replace('_url', ''))
      })
      return img_references
    }else{
      return 'image'
    }
  }


  const [quantity, setQuantity] = useState(1);
  const [myCollectionSubmited, setMyCollectionSubmited] = useState(null);
  const [alreadyInWishlist, setAlreadyInWishlist] = useState(blueprintImage.already_in_wishlist);
  const [ showSuccessFlashMessage, setShowSuccessFlashMessage ] = useState(false)
  const [successFlashMessage, setSuccessFlashMessage] = useState('')
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [showFullScreenLoadingOverlay, setShowFullScreenLoadingOverlay] = useState(false)
  const [showZoomImg, setShowZoomImg] = useState(false)
  const [showMarketFlow, setShowMarketFlow] = useState(false)
  const [openAccordionTab0, setOpenAccordionTab0] = useState(viewAigPopulation !== true)
  const [openAccordionTab1, setOpenAccordionTab1] = useState(viewAigPopulation === true)
  const [showAlertPopupMyCollection, setShowAlertPopupMyCollection] = useState(false)
  const [showAlertPopupWishlist, setShowAlertPopupWishlist] = useState(false)
  const isSingleCard = compareStrings(blueprintImage.blueprint.category.name, 'singles')
  const isBoosterPack = compareStrings(blueprintImage.blueprint.category.name, 'booster pack')
  const gradings = (['10.5', '10.0', '9.5', '9.0', '8.5', '8.0', '7.5', '7.0', '6.5', '6.0', '5.5', '5.0', '4.5', '4.0', '3.5', '3.0', '2.5', '2.0', '1.5', '1.0', 'authentic'].concat(!isSingleCard && !isBoosterPack ? ['case_fresh'] : []))
  const [renderCarouselImageIndex, setRenderCarouselImageIndex] = useState((!blueprintImage.has_carousel_images) ? null : 0)
  const [carouselImageType, setCarouselImageType] = useState('image')
  const [modalCarouselImageType, setModalCarouselImageType] = useState(initializeCarouselImageType())
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [successMessage, setSuccessMessage] = useState({message: "", linkTo: "", linkContent: ""})
  const [showRequiredLoginModal, setShowRequiredLoginModal] = useState(false);

  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useComponentVisible(false);


  const handleClearSessionStorage = (key) => {
    sessionStorage.removeItem(key);
  }


  // Funzione che permette di aggiungere la carta corrente alla my collection dell'utente,
  // nelle quantità da lui specificate
  const addCardToMyCollectionHandler = () => {
    if (logged_in_user) {
      const body = {
        game_id: game_id,
        items: [
          {
            id: blueprintImage.id,
            blueprint_id: blueprintImage.blueprint_id,
            language: blueprintImage.language,
            quantity: quantity ? quantity : 1
          },
        ],
      };

      if (quantity > 30)
        setShowFullScreenLoadingOverlay(true)

      const url = "/my_collections";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      })
        .then((res) => {
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          setMyCollectionSubmited(data.id);
          setShowSuccessModal(true)
          setSuccessMessage({
            message: I18n.t('js.common.actionsWithCards.successAddTO'),
            linkTo: `/my_collections/${data.id}/edit`,
            linkContent: 'collection'
          })
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  };


  // Funzione che permette di aggiungere la carta corrente alla wishlist dell'utente
  const addCardToWishlistHandler = () => {
    if (logged_in_user) {
      const url = "/wishlists";

      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({items: [blueprintImage.id]}),
      })
        .then((res) => {
          setShowFullScreenLoadingOverlay(false)
          if (!res.ok)
            throw Error("An error occour during saving data on the database");
          else
            return res.json();
        })
        .then((data) => {
          setAlreadyInWishlist(data.id)
          setShowSuccessFlashMessage(true)
          setSuccessFlashMessage(I18n.t('js.indexCardPage.productAddedToWishlist'))
        })
        .catch((error) => {
          console.error("ERROR:", error);
          setShowErrorModal(true);
        });
    }
  }

  // Funzione che gestisce la chiusura degli Items dell'accordion
  const handleAccordionItemShow = (clickedTab) => {

    // se ho cliccato il tab 0 e questo era già aperto cambio solo il suo stato
    if (clickedTab == 0 && !openAccordionTab1) {
      setOpenAccordionTab0(!openAccordionTab0)
    }

    // se ho cliccato il tab 1 e questo era già aperto cambio solo il suo stato
    if (clickedTab == 1 && !openAccordionTab0) {
      setOpenAccordionTab1(!openAccordionTab1)
    }

    // se ho cliccato il tab 0 e questo non era già aperto lo apro e chiudo il tab che era aperto e viceversa per il tab 1
    if ((clickedTab == 0 && openAccordionTab1 && !openAccordionTab0) ||
      (clickedTab == 1 && openAccordionTab0 && !openAccordionTab1)) {
      setOpenAccordionTab0(!openAccordionTab0)
      setOpenAccordionTab1(!openAccordionTab1)
    }

  }

  // Funzione che apre un pop up che chiede conferma all'utente circa la sua volontà di inserire nella sua
  // my collection / wishlist le carte che ha selezionato sull'interfaccia grafica
  const openAlertPopup = (popupType) => {
    if (logged_in_user) {
      switch (popupType) {
        case 'wishList':
          setShowAlertPopupWishlist(true)
          break;
        case 'myCollection':
          setShowAlertPopupMyCollection(true)
          break;
      }
    } else {
      setShowRequiredLoginModal(true)
    }
  }


  // Funzione che permette di mostrare in full-screen l'immagine ingrandita della carta
  const handleShowLargeImage = (e, blueprintImage) => {
    e.stopPropagation();
    if (blueprintImage && (blueprintImage.has_carousel_images || blueprintImage.xx_large_image_url)) {
      setShowZoomImg(true)
    }
  }


  // Funzione che permette di mostrare in full-screen la modale con l'andamento di mercato della carta
  const handleShowMarketFlow = () => {
    if (marketFlow && marketFlow.length > 0) {
      setShowMarketFlow(true)
    }
  }


  // Funzione che cambia l'immagine da renderizzare a video del prodotto sealed in questione
  const handleDisplayCarouselImage = (newCarouselImageIndex) => {
    if (blueprintImage.has_carousel_images) {
      const carousel_images_length = blueprintImage.medium_carousel_images_urls.length
      if (newCarouselImageIndex < 0)
        newCarouselImageIndex = carousel_images_length - 1
      else if (newCarouselImageIndex >= carousel_images_length)
        newCarouselImageIndex = 0

      setRenderCarouselImageIndex(newCarouselImageIndex)
      const newImageType = Object.keys(blueprintImage.medium_carousel_images_urls[newCarouselImageIndex])[0].replace('medium_', '').replace('_url', '')
      setCarouselImageType(newImageType)
    }
  }

  const renderArtwork = () => {
    let artwork = getArtwork(blueprintImage)
    if (artwork) {
      return <p className="text-center text-space">{"[" + artwork + "]"}</p>
    } else {
      return ''
    }
  }

  const showActionPopup = () => {
    if (window.innerWidth < IPAD_WIDTH) {
      $('.bubble').css('top', e.pageY + 40 - $(window).scrollTop() + 'px')
      $('.bubble').css('left', e.pageX - 105 + 'px')
    } else {

        // nelle altre visualizzazioni
        // Se sto visualizzando la pagina con la tabella con l'immagine
        // assegno come valore di Top al popup quello derivante da:
        // La posizione del bordo superiore del bottone cliccatoin pagina a cui sommo:
        // 50px altezza del bottone stesso 20px lunghezza diagonale della feccia sul popup
        // sottraggo l'eventuale scroll fatto dall'utente
        $('.bubble').css('top', $('#add_to').offset().top - 80 - $(window).scrollTop() + 'px')

        //Assegno il valore alla posizione left del popup prendendo la posizione x del bordo sinistro del bottone e sottraendo
        // la larghezza complessiva (popup + quadrato per la freccia) in px del popup
        $('.bubble').css('left', $('#add_to').offset().left + 65 + 'px')
    }
    setIsComponentVisible(true)
  }

  // intercetto l'inizio dello scroll e nascondo il popup
  $(window).scroll(function () {
    setIsComponentVisible(false);
  })


  // Funzione che parsa il nome del prodotto e l'artwork da renderizzare a video
  function parseProductNameAndArtwork(blueprintImage) {
    let nameToReturn = (blueprintImage.quantity ? blueprintImage.quantity.toString() + ' ' : '') + blueprintImage.name
    if (blueprintImage.artworks) {
      const artwork = getArtwork(blueprintImage)
      if (artwork) {
        nameToReturn = nameToReturn + ' - '

        if (artwork.indexOf(' - ') > -1) {
          const splittedArtworks = artwork.split(' - ')

          for (const splittedArtwork of splittedArtworks) {
            if (nameToReturn.indexOf(splittedArtwork.trim()) === -1)
              nameToReturn = nameToReturn + splittedArtwork
          }
        } else if (nameToReturn.indexOf(artwork.trim()) === -1){
          nameToReturn = nameToReturn + artwork
        }

        if (nameToReturn[nameToReturn.length - 2] && nameToReturn[nameToReturn.length - 2] === '-')
          nameToReturn = nameToReturn.slice(0, -2)
      }
    }

    return nameToReturn
  }




  const renderGradedProductsByEncasing = () => {
    return (
      (gradedProductsByEncasingCount['sleeve'] > 0 &&
        gradedProductsByEncasingCount['case'] > 0) ||
      isSingleCard
    )
  }


  const blueprintImageNames = displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language)
  const eraNames = displayTranslations(blueprintImage.en_era_name, blueprintImage.era_name, blueprintImage.language)

  return (
    <React.Fragment>
      <div className="custom-font-text">
        <div className="row d-flex justify-content-center px-5">

          {/*card image and button*/}
          <div className=" col-xs-12 col-md-6 p-0">
            <div className="row d-flex justify-content-center">

              {
                blueprintImageNames.length > 1 ?
                  <React.Fragment>
                    <p className="card-name text--size-title text-space text-center d-md-none pt-3">
                      {
                        parseBlueprintImageNameAndEdition(blueprintImage.game.name, blueprintImage.edition, blueprintImageNames[0], blueprintImage.blueprint.category.name)
                      }
                    </p>

                    <p className="card-eng-name text--size-title text-space text-center d-md-none">
                      {blueprintImageNames[1]}
                    </p>
                  </React.Fragment>
                  :
                  <p className="card-name text--size-title text-space text-center d-md-none pt-3">
                    {
                      parseBlueprintImageNameAndEdition(blueprintImage.game.name, blueprintImage.edition, blueprintImageNames[0], blueprintImage.blueprint.category.name)
                    }
                  </p>
              }

              <div className="d-md-none">
                {
                  blueprintImage.artworks ? renderArtwork() : ''
                }
              </div>
            </div>

            <div
              className="row d-flex justify-content-start mt-10px flex-md-column text-sm-center pl-sm-5 pr-sm-5 pt-sm-3">

              <div className="col-xs-6 col-sm-12 p-0  d-none d-md-flex cardinfo__title--flex-desktop bg-white pt-sm-3">

                {
                  blueprintImageNames.length > 1 ?
                    <React.Fragment>
                      <p className="card-name text--size-title text-center text-space">
                        {
                          parseBlueprintImageNameAndEdition(blueprintImage.game.name, blueprintImage.edition, blueprintImageNames[0], blueprintImage.blueprint.category.name)
                        }
                      </p>
                      <p className="card-eng-name text--size-title text-center text-space">
                        {blueprintImageNames[1]}
                      </p>
                    </React.Fragment>
                    :
                    <p className="card-name text--size-title text-center text-space">
                      {
                        parseBlueprintImageNameAndEdition(blueprintImage.game.name, blueprintImage.edition, blueprintImageNames[0], blueprintImage.blueprint.category.name)
                      }
                    </p>
                }

                {
                  blueprintImage.artworks ? renderArtwork() : ''
                }
              </div>

              <div
                className={`col-xs-12 col-sm-12 p-0 pt-sm-3 mb-5 text-center ${window.innerWidth >= IPAD_WIDTH && 'bg-white'}`}>
                <ShowBlueprintImageFrontImage
                  size={window.innerWidth > IPAD_WIDTH ? 'large' : 'medium'}
                  blueprintImage={blueprintImage}
                  handleShowLargeImage={handleShowLargeImage}
                  additionalClasses={"image-card-show-page m-auto round-right round-left"}
                  renderCarouselImageIndex={renderCarouselImageIndex}
                  carouselImageType={carouselImageType}
                  isBackImage={false}
                />
                {
                  blueprintImage.has_carousel_images &&
                  <div className="d-flex justify-content-center mt-3">
                    <i className="fas fa-chevron-left cursor-pointer mr-2"
                       onClick={(e) => handleDisplayCarouselImage(renderCarouselImageIndex - 1)}
                    />
                    {
                      blueprintImage.medium_carousel_images_urls.map((image, index) => {
                        return <div style={{
                          width: '15px',
                          height: '15px',
                          borderRadius: '50%',
                          marginTop: '1px',
                          border: renderCarouselImageIndex === index ? 'solid 1px #212529' : 'solid 1px #212529',
                          backgroundColor: renderCarouselImageIndex === index ? `#212529` : 'white'
                        }}
                                    className="ml-1px cursor-pointer"
                                    onClick={(e) => handleDisplayCarouselImage(index)}
                                    key={index}
                        />
                      })
                    }
                    <i className="fas fa-chevron-right cursor-pointer ml-4"
                       onClick={(e) => handleDisplayCarouselImage(renderCarouselImageIndex + 1)}
                    />
                  </div>
                }
              </div>

              <div className="d-flex col-xs-12 col-sm-12 flex-directions-column p-0 pl-3 d-md-none">

                {
                  !disable_marketplace && hasOffers &&
                    <div className="d-flex justify-content-center mt-md-5">
                      <button
                        type="button"
                        className="btn btn-standard bg-dark text-light pt-1 pr-5 btn-standard-resized cardinfo__actions-buttons--width p-5px-imp noselect text--size-normal-imp pt-10px-imp"
                        onClick={() => window.location.href = `/products/${blueprintImage.id}`}
                      >
                        <i className="fa fa-eye icon-in-btn-size mr-8px"/>
                        {I18n.t('js.common.button.viewOffers')}
                      </button>
                    </div>
                }

                {
                  !disable_marketplace && marketFlow && marketFlow.length > 0 &&
                    <div className="d-flex mt-3 justify-content-center">
                      <button type="button"
                              className="btn btn-standard bg-dark text-light pt-1 pr-5 btn-standard-resized cardinfo__actions-buttons--width p-5px-imp noselect minH-40px-imp text-on-new-line text--size-normal-imp"
                              onClick={handleShowMarketFlow}>
                        <i className="fa fa-line-chart icon-in-btn-size mr-8px"/>
                        {I18n.t('js.marketChart.viewMarketFlow')}
                      </button>
                    </div>
                }

                <div className="d-flex justify-content-center mt-3 text-weight-700">
                  {
                    alreadyInWishlist > 0 ?
                      <p
                        className="mt-2 text-aiBlue mb-0 text--size-09rem text-center"
                      >
                        {I18n.t('js.common.thisCardIn')} &nbsp;
                        <a
                          href={`/wishlists/${alreadyInWishlist}/edit`}
                          className="data-structure-link"
                          style={{color: "inherit"}}>
                          {I18n.t('js.common.yourWishlist')}
                        </a>
                      </p>
                    :
                      !disable_marketplace &&
                        <button type="button"
                                className="btn btn-standard bg-aig-gradient text-light pb-1 pr-5 btn-standard-resized cardinfo__actions-buttons--width p-5px-imp noselect minH-40px-imp text-on-new-line text--size-normal-imp"
                                onClick={() => openAlertPopup('wishList')}>
                          <i className="fa fa-plus-circle icon-in-btn-size mr-8px"/>
                          {I18n.t('js.common.button.addInWishlist')}
                        </button>
                  }
                </div>

                {
                  !disable_marketplace &&
                    <div className="d-flex mt-3 justify-content-center">
                      <button type="button"
                              className="btn btn-standard bg-aig-gradient text-light pt-1 pr-5 btn-standard-resized cardinfo__actions-buttons--width p-5px-imp noselect minH-40px-imp text-on-new-line text--size-normal-imp"
                              onClick={() => openAlertPopup('myCollection')}>
                        <i className="fa fa-plus-circle icon-in-btn-size mr-8px"/>
                        {I18n.t('js.common.button.addInMyCollection')}
                      </button>
                    </div>
                }

                {
                  !disable_marketplace &&
                    <div className="d-flex align-items-center form-group mt-3 cardinfo__quantity-input--width">
                      <label
                        className="text-dark text-weight-500 text--size-normal text-center mb-0">{I18n.t('js.common.quantity')}:&nbsp;</label>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                          </Tooltip>
                        }
                      >
                        <div>
                          <input
                            className="form-control ml-4 mb-1"
                            value={quantity}
                            name="bluprint_image_quantity"
                            type="number"
                            style={{width: "70px"}}
                            onKeyDown={(e) => onKeyDownQuantity(e)}
                            onChange={(e) => {
                              if (e.target.value === '' || e.target.value > 0) {
                                setQuantity(e.target.value);
                              }
                            }
                            }
                            data-id={blueprintImage.id}
                          />
                        </div>
                      </OverlayTrigger>
                    </div>
                }
              </div>

              <div className="col-6 col-xs-6 col-sm-12 flex-directions-column p-0 d-none d-md-flex bg-white">

                <div className={`{row m-auto d-flex justify-content-center ${window.innerWidth > DESKTOP_WIDTH ? 'w-50' : 'w-100' }`}>
                  {
                    !disable_marketplace && hasOffers &&
                      <div className="w-25 justify-content-center mt-4">
                        <button type="button"
                                id="offers"
                                className="btn-standard bg-dark text-light btn-standard-resized p-2"
                                onClick={() => window.location.href = `/products/${blueprintImage.id}`}>
                          <i className="fa fa-eye icon-in-btn-size fa-lg"/>
                        </button>
                        <p
                          className="text--size-small text--white-space-no-wrap text-line-height-1 mt-1 mb-0">{I18n.t('js.common.button.viewOffersShort')}</p>
                      </div>
                  }

                  {
                    !disable_marketplace && marketFlow && marketFlow.length > 0 &&
                      <div className="w-25 mt-4 justify-content-center">
                        <button type="button"
                                id="market-flow"
                                className="btn-standard bg-dark text-light btn-standard-resized p-2"
                                onClick={handleShowMarketFlow}>
                          <i className="fa fa-line-chart icon-in-btn-size fa-lg"/>
                        </button>
                        <p
                          className="text--size-small text-line-height-1 mt-1 mb-0">{I18n.t('js.common.button.marketFlowShort')}</p>
                      </div>
                  }

                  {
                    !disable_marketplace &&
                      <div className="w-25 mt-4 justify-content-center">
                        <button type="button"
                                id="add_to"
                                className="btn-standard bg-aig-gradient text-light btn-standard-resized p-2"
                                onClick={() => showActionPopup()}>
                          <i className="fa fa-plus-circle fa-lg"/>
                        </button>
                        <p
                          className="text--size-small text--white-space-no-wrap text-line-height-1 mt-1">{I18n.t('js.common.button.addTo')}</p>
                      </div>
                  }
                </div>

                <div className="d-flex justify-content-center  text-weight-700">
                  {
                    alreadyInWishlist > 0 &&
                      <p
                        className="mt-2 text-aiBlue mb-0 text--size-09rem text-center"
                      >
                        {I18n.t('js.common.thisCardIn')} &nbsp;
                        <a
                          href={`/wishlists/${alreadyInWishlist}/edit`}
                          className="data-structure-link"
                          style={{color: "inherit"}}>
                          {I18n.t('js.common.yourWishlist')}
                        </a>
                      </p>
                  }
                </div>

                {
                  !disable_marketplace &&
                    <div
                      className="d-flex align-items-center justify-content-center form-group mt-3 cardinfo__quantity-input--width">
                      <label
                        className="text-dark text-weight-500 text--size-normal text-center mb-0">{I18n.t('js.common.quantity')}:&nbsp;</label>
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id={`tooltip-top`}>
                            <p>{I18n.t('js.common.quantityTooltipContent')}</p>
                          </Tooltip>
                        }
                      >
                        <div>
                          <input
                            className="form-control ml-4 mb-1"
                            value={quantity}
                            name="bluprint_image_quantity"
                            type="number"
                            style={{width: "70px"}}
                            onKeyDown={(e) => onKeyDownQuantity(e)}
                            onChange={(e) => {
                              if (e.target.value === '' || e.target.value > 0) {
                                setQuantity(e.target.value);
                              }
                            }
                            }
                            data-id={blueprintImage.id}
                          />
                        </div>
                      </OverlayTrigger>
                    </div>
                }
              </div>

              <div ref={ref} className={`size-h-3px-w-3px  ${!isComponentVisible && 'd-none'}`}>
                <div className="bubble position-fixed shadow p-2">
                  <p className="text-weight-700 text-night-blue text-center text-space">
                    {I18n.t('js.indexSealedPage.addProductTo')}
                  </p>
                  {
                    !disable_marketplace &&
                      <React.Fragment>
                        <div
                          className={`border-bottom-dark d-flex justify-content-center pt-20px pb-10px pl-3 pr-3 cursor-pointer ${alreadyInWishlist > 0 && 'text--disabled'}`}
                          id="add_to_wishlist"
                          onClick={() => !alreadyInWishlist > 0 && openAlertPopup("wishList")}>
                          <i className="fas fa-heart mr-3 w-5 col-2 p-0 mt-4px"></i>
                          <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInWishlistShort')}</p>
                        </div>
                        <div className="d-flex justify-content-center pt-10px pb-10px pl-3 pr-3 cursor-pointer"
                             id="add_to_my_collection"
                             onClick={() => openAlertPopup("myCollection")}>
                          <i className="fas fa-gem mr-3 w-5 col-2 p-0 mt-4px"/>
                          <p className="col-10 text-left p-0">{I18n.t('js.common.button.addInMyCollectionShort')}</p>
                        </div>
                        <div className="pointer"></div>
                      </React.Fragment>
                  }
                </div>
              </div>

            </div>
          </div>


          {/*card info*/}
          <div className="col-xs-12 col-md-6 p-0 mb-70px-imp">
            <Accordion defaultActiveKey={!viewAigPopulation ? "0" : "1"} className="w-100">
              <Card className="border-none">
                <Accordion.Toggle as={Card.Header} eventKey="0"
                                  className={`border-none bg-trasparent p-0 ${openAccordionTab0 ? 'border-bottom-active' : 'border-bottom-dark'} mb-0 minH-60px cursor-pointer`}
                                  onClick={() => handleAccordionItemShow(0)}>
                  <div className="position-relative">
                    <h3 id="card-detail" className={`${openAccordionTab0 && 'text-aiBlue'} mb-0 text-bold`}>
                      {isSingleCard ? I18n.t('js.cardInfoPage.cardDetail') : I18n.t('js.cardInfoPage.productDetail')}
                    </h3>
                    <i
                      className={`${openAccordionTab0 ? 'fa fa-times icon--color-active' : 'fa fa-chevron-down'} position-absolute accordion__arrow--position`}/>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                  <Card.Body className="p-0">
                    <div className="mt-20px">
                      {
                        blueprintImage.collector_number &&
                        <p>
                          <b>{I18n.t('js.cardInfoPage.cardNumber')}:</b>&nbsp;
                          {blueprintImage.collector_number}
                        </p>
                      }

                      {
                        blueprintImage.print_sheet_code &&
                        <p>
                          <b>{I18n.t('js.cardInfoPage.sheetCode')}:</b>&nbsp;
                          {blueprintImage.print_sheet_code}
                        </p>
                      }
                      <p><b>{I18n.t('js.cardInfoPage.game')}:</b>&nbsp;
                        <a id="game-link" href={isSingleCard ?
                          `/games/${game_id}/expansions`
                          :
                          `/games/${game_id}/sealed`
                        }
                           onClick={(e) => handleClearSessionStorage(isSingleCard ? EXPANSIONS_KEY_FOR_SESSION_STORAGE : SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE)}>
                          <GameNameParser game_name={blueprintImage.game.name} />
                        </a>
                      </p>

                      {
                        !isSingleCard &&
                          <p>
                            <b>{I18n.t('js.cardInfoPage.category')}:</b>
                            &nbsp;
                            { parseCategoryName(blueprintImage.blueprint.category.name) }
                          </p>
                      }

                      {
                        (blueprintImage.era_name || blueprintImage.en_era_name) &&
                          <p>
                            <b>{I18n.t('js.cardInfoPage.era')}:</b>&nbsp;
                            <a id="era-link" href={isSingleCard ?
                              `/games/${game_id}/expansions?page=1&era_id=${blueprintImage.era_id}`
                              :
                              `/games/${game_id}/sealed?page=1&era_id=${blueprintImage.era_id}`
                            }
                               onClick={(e) => handleClearSessionStorage(isSingleCard ? EXPANSIONS_KEY_FOR_SESSION_STORAGE : SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE)}>
                              {
                                eraNames.length > 1 ?
                                  eraNames[0] +
                                  " (" + eraNames[1] + ")" :
                                  eraNames[0]
                              }
                            </a>
                          </p>
                      }

                      <p className="mb-0">
                        <b>{I18n.t('js.cardInfoPage.expansions')}:</b>&nbsp;
                      </p>
                      <ul className="ml-5">
                        {
                          blueprintImage.all_expansions.map((expansion) => {
                            return <li key={expansion[0]} className="mt-10px">
                              <a
                                id="expansion-link"
                                href={`/games/${game_id}/expansions/${expansion[2]}/blueprint_images?language=${blueprintImage.language}`}
                                onClick={(e) => handleClearSessionStorage(isSingleCard ? BLUEPRINT_IMAGES_KEY_FOR_SESSION_STORAGE : SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE)}>
                                {expansion[0]}
                                {
                                  expansion[1].map((icon_url) => {
                                    return <img src={icon_url} key={icon_url} alt="" className="ml-1"
                                                style={{maxWidth: '35px'}}/>
                                  })
                                }
                              </a>
                            </li>
                          })}
                      </ul>
                      <div className="d-flex align-items-center mb-3">
                        <b>{I18n.t('js.cardInfoPage.language')}:</b>&nbsp;
                        <span className="mr-2">
                          { parseLanguage(blueprintImage.language_filter) }
                        </span>
                        <LanguageFlag
                          language={blueprintImage.language}
                          maxHeight={'15px'}
                        />
                      </div>
                      {
                        blueprintImage.version && blueprintImage.version !== '' &&
                        <p>
                          <b>{I18n.t('js.cardInfoPage.version')}:</b>&nbsp;
                          {titleize(blueprintImage.version)}
                        </p>
                      }
                      {
                        blueprintImage.rarity && !compareStrings(blueprintImage.rarity, 'no rarity') &&
                          <p>
                            <b>{I18n.t('js.cardInfoPage.rarity')}:</b>&nbsp;
                            {titleize(blueprintImage.rarity)}
                            {
                              blueprintImage.rarity_logo_url &&
                              <img
                                src={blueprintImage.rarity_logo_url}
                                style={{height: "20px", width: "20px"}}
                                alt=""
                                className="ml-2"
                              />
                            }
                          </p>
                      }
                      {
                        blueprintImage.edition && blueprintImage.edition !== '' && !compareStrings(blueprintImage.edition, 'Undefined') &&
                        <p><b>{I18n.t('js.cardInfoPage.edition')}:</b>&nbsp; {blueprintImage.edition}</p>
                      }
                      {
                        blueprintImage.released_at && blueprintImage.released_at !== '' &&
                        <p><b>{I18n.t('js.cardInfoPage.release')}:</b>&nbsp; {blueprintImage.released_at}</p>
                      }
                      {
                        blueprintImage.promo_event &&
                        <p><b>{I18n.t('js.cardInfoPage.event')}:</b>&nbsp; {blueprintImage.promo_event}</p>
                      }
                      {
                        blueprintImage.web_description &&
                        <p><b>{I18n.t('js.cardInfoPage.webDescription')}:</b>&nbsp; {blueprintImage.web_description}</p>
                      }
                      {
                        blueprintImage.content_and_quantity &&
                        <p>
                          <b>{I18n.t('js.cardInfoPage.contentAndQuantity')}:</b>&nbsp; {blueprintImage.content_and_quantity}
                        </p>
                      }
                      {
                        blueprintImage.contained_products && blueprintImage.contained_products.length > 0 &&
                        <React.Fragment>
                          <p><b>{I18n.t('js.cardInfoPage.content')}:</b></p>
                          <ul className="ml-5">
                            {
                              blueprintImage.contained_products.map((content) => {
                                return <li key={content.id} className="mt-10px">
                                  <a href={`/blueprint_images/${content.id}`}>
                                    { parseProductNameAndArtwork(content) }
                                  </a>
                                </li>
                              })}
                          </ul>
                        </React.Fragment>
                      }
                      {
                        blueprintImage.container_products && blueprintImage.container_products.length > 0 &&
                        <React.Fragment>
                          <p><b>{I18n.t('js.cardInfoPage.container')}:</b></p>
                          <ul className="ml-5">
                            {
                              blueprintImage.container_products.map((content) => {
                                return <li key={content.id} className="mt-10px">
                                  <a href={`/blueprint_images/${content.id}`}>
                                    { parseProductNameAndArtwork(content) }
                                  </a>
                                </li>
                              })}
                          </ul>
                        </React.Fragment>
                      }
                      {
                        !isSingleCard &&
                        <p>
                          <a href={`/games/${game_id}/sealed?page=1&expansion_id=${blueprintImage.expansion_id}`}
                             onClick={(e) => handleClearSessionStorage(SEALED_PRODUCTS_KEY_FOR_SESSION_STORAGE)}>
                            {I18n.t('js.cardInfoPage.viewExpansion')}
                          </a>
                        </p>
                      }
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
              <Card className="border-none ">
                <Accordion.Toggle as={Card.Header} eventKey="1"
                                  className={`border-none bg-trasparent p-0 ${openAccordionTab1 ? 'border-bottom-active' : 'border-bottom-dark'} mb-0 minH-60px cursor-pointer`}
                                  onClick={() => handleAccordionItemShow(1)}>
                  <div className="position-relative">
                    <h3 id="AiG-stock" className={`${openAccordionTab1 && 'text-aiBlue'} mb-0 text-bold`}>
                      {I18n.t('js.cardInfoPage.cardCheckStock')}
                    </h3>
                    <i
                      className={`${openAccordionTab1 ? 'fa fa-times icon--color-active' : 'fa fa-chevron-down'} position-absolute accordion__arrow--position`}/>
                  </div>
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="1">
                  <Card.Body className="p-0">
                    <div className="mt-20px">
                      <div className="my-5">
                        <p className="my-0">
                          <b>{isSingleCard ? I18n.t('js.cardInfoPage.totalGradedCards') : I18n.t('js.cardInfoPage.totalGradedProducts')}:</b>&nbsp;
                          {gradedCardsCount}
                        </p>

                        {
                          renderGradedProductsByEncasing() &&
                            <React.Fragment>
                              <p className="mt-2 mb-0">
                                <b>{isSingleCard ? I18n.t('js.cardInfoPage.totalGradedCardsIn') : I18n.t('js.cardInfoPage.totalGradedProductsIn')} {parseEncasing('case', blueprintImage.blueprint.category.name).toLowerCase()}:</b>&nbsp;
                                {gradedProductsByEncasingCount['case']}
                              </p>

                              <p className="mt-2 mb-0">
                                <b>{isSingleCard ? I18n.t('js.cardInfoPage.totalGradedCardsIn') : I18n.t('js.cardInfoPage.totalGradedProductsIn')} {parseEncasing('sleeve', blueprintImage.blueprint.category.name).toLowerCase()}:</b>&nbsp;
                                {gradedProductsByEncasingCount['sleeve']}
                              </p>
                            </React.Fragment>
                        }
                      </div>

                      <div className="row text-center mb-4 mt-2">
                        <div className="col-3 d-flex justify-content-center align-items-end">
                          <small><b>{I18n.t('js.cardInfoPage.vote').toUpperCase()}</b></small>
                        </div>
                        <div className="col-3 d-flex justify-content-center align-items-end">
                          <small><b>{I18n.t('js.cardInfoPage.grading').toUpperCase()}</b></small>
                        </div>
                        <div className="col-3 d-flex justify-content-center align-items-end">
                          <small><b>{(isSingleCard ? I18n.t('js.cardInfoPage.gradedCards') : I18n.t('js.cardInfoPage.graded')).toUpperCase()}</b></small>
                        </div>
                        <div className="col-3 d-flex justify-content-center align-items-end">
                          <small><b>{I18n.t('js.cardInfoPage.withQualifiers').toUpperCase()}</b></small>
                        </div>
                      </div>

                      {gradings.map((n) => (
                        gradingsByScore[`${n}`] && gradingsByScore[`${n}`] > 0 &&
                          <div className="row text-center mb-4" key={n}>
                            <div className="col-3 p-0 align-self-center">
                              <b className="color-aiG-skyBlue-imp">
                                {n === '10.5' ? '10' : titleize(n.replace('.0', '').replaceAll('_', ' '))}
                              </b>
                            </div>
                            
                            <div className="col-3 p-0 align-self-center">
                              <small>
                                {
                                  !['authentic', 'case_fresh'].includes(n) ?
                                    <b>{getGradingNameFromGrade(n)[0].toUpperCase()}</b>
                                  :
                                    <b>&nbsp;</b>
                                }
                              </small>
                            </div>
                            
                            <div className="col-3 p-0 align-self-center">
                              <b className="color-aiG-skyBlue-imp">
                                {parseBigInteger(gradingsByScore[`${n}`] || 0)}
                              </b>

                              {
                                renderGradedProductsByEncasing() &&
                                  <React.Fragment>
                                    <p className="mb-0">
                                      <small>
                                        {titleize(parseEncasing('case', blueprintImage.blueprint.category.name).toLowerCase())}:&nbsp;
                                        {isDefined(gradingsByEncasing['case'][`${n}`]) ? gradingsByEncasing['case'][`${n}`] : '0'}
                                      </small>
                                    </p>

                                    <p className="mb-0">
                                      <small>
                                        {titleize(parseEncasing('sleeve', blueprintImage.blueprint.category.name).toLowerCase())}:&nbsp;
                                        {isDefined(gradingsByEncasing['sleeve'][`${n}`]) ? gradingsByEncasing['sleeve'][`${n}`] : '0'}
                                      </small>
                                    </p>
                                  </React.Fragment>
                              }
                            </div>

                            <div className="col-3 p-0 align-self-center">
                              <b className="color-aiG-skyBlue-imp">
                                {parseBigInteger(qualifiersByScore[`${n}`] || 0)}
                              </b>
                            </div>
                          </div>
                      ))}
                    </div>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            </Accordion>
          </div>
        </div>

        <SuccessFlashMessage
          showSuccessFlashMessage={showSuccessFlashMessage}
          setShowSuccessFlashMessage={setShowSuccessFlashMessage}
          successMessage={successFlashMessage}
        />

        <ErrorModal
          showErrorModal={showErrorModal}
          setShowErrorModal={setShowErrorModal}
        />

        <FullScreenLoadingOverlay
          showFullScreenLoadingOverlay={showFullScreenLoadingOverlay}
          textFullScreenLoadingOverlay={`${I18n.t('js.indexCardPage.addingCardSpinner')}`}
        />
      </div>

      <ShowLargeImageModal
        blueprintImage={blueprintImage}
        showZoomImg={showZoomImg}
        setShowZoomImg={setShowZoomImg}
        renderCarouselImageIndex={renderCarouselImageIndex}
        setRenderCarouselImageIndex={handleDisplayCarouselImage}
        // carouselImageType={carouselImageType}
        carouselImageType={modalCarouselImageType}

      />

      {/*Alert per add in My collection*/}
      <AlertPopup
        showAlertPopup={showAlertPopupMyCollection}
        onSuccess={addCardToMyCollectionHandler}
        onDiscard={setShowAlertPopupMyCollection}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyCollectionTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMycollectionContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      {/*Alert per add in My wishlist*/}
      <AlertPopup
        showAlertPopup={showAlertPopupWishlist}
        onSuccess={addCardToWishlistHandler}
        onDiscard={setShowAlertPopupWishlist}
        popupTitle={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistTitle')}`}
        popupContent={`${I18n.t('js.indexCardPage.alertPopupBeforeAddCard.inMyWishlistContent')}`}
        cancelButtonText={`${I18n.t('js.common.button.cancel').toUpperCase()}`}
        confirmButtonText={`${I18n.t('js.common.button.confirmAdd').toUpperCase()}`}
      />

      <SuccessModal
        showSuccessModal={showSuccessModal}
        setShowSuccessModal={setShowSuccessModal}
        successMessage={successMessage}
      />

      <RequiredLoginAlertPopup
        showRequiredLoginAlertPopup={showRequiredLoginModal}
        onClose={setShowRequiredLoginModal}
      />

      <BlueprintImageFlowMarketModal
        marketFlow={marketFlow}
        showMarketFlow={showMarketFlow}
        setShowMarketFlow={setShowMarketFlow}
      />
    </React.Fragment>

  );
}

export default ShowBlueprintImage;
